const AimsObjectives = () => {
    return (
        <div className="container aims-page">

            {/* PAGE INTRO */}

            <div className="admission-intro aims-intro">

                <h2>
                    Aims &amp; Objectives
                </h2>

                <div className="admission-title-line"></div>

                <p>
                    The primary aim of Nav Jeevan Mission School is to provide
                    quality education that nurtures the intellectual, moral,
                    social, emotional and physical development of every student.
                    The school strives to create a safe, disciplined and
                    inspiring learning environment where students are encouraged
                    to discover their potential, develop confidence and become
                    responsible citizens.
                </p>
                <br />
                <h3>
                    Our objectives are:
                </h3>

            </div>


            {/* OBJECTIVES */}

            <div className="admission-steps aims-steps">

                {/* 01 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        01
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To provide quality, holistic and value-based
                            education.
                        </p>

                    </div>

                </div>


                {/* 02 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        02
                    </div>

                    <div className="admission-step-content">
                        <p>
                            To develop students into responsible, disciplined
                            and compassionate citizens.
                        </p>

                    </div>

                </div>


                {/* 03 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        03
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To promote academic excellence, critical thinking,
                            creativity and innovation.
                        </p>

                    </div>

                </div>


                {/* 04 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        04
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To nurture leadership qualities, self-confidence and
                            a spirit of teamwork.
                        </p>

                    </div>

                </div>


                {/* 05 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        05
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To encourage respect for God, parents, teachers,
                            elders, society and the nation.
                        </p>

                    </div>

                </div>


                {/* 06 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        06
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To develop moral values, integrity, honesty,
                            discipline and a sense of responsibility.
                        </p>

                    </div>

                </div>


                {/* 07 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        07
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To provide opportunities for sports, cultural,
                            artistic and co-curricular activities.
                        </p>

                    </div>

                </div>


                {/* 08 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        08
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To equip students with digital, technological and
                            life skills necessary for the changing world.
                        </p>

                    </div>

                </div>


                {/* 09 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        09
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To encourage students to respect diversity, human
                            dignity and the environment.
                        </p>

                    </div>

                </div>


                {/* 10 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        10
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To prepare young people to face the challenges of
                            the future with courage, wisdom and a positive
                            attitude.
                        </p>

                    </div>

                </div>


                {/* 11 */}

                <div className="admission-step">

                    <div className="admission-step-number">
                        11
                    </div>

                    <div className="admission-step-content">

                        <p>
                            To inspire students to use their knowledge and
                            abilities in the service of society and humanity.
                        </p>

                    </div>

                </div>

            </div>


            {/* VISION */}

            <div className="admission-journey aims-vision">

                <div className="journey-content">

                    <h2>
                        Our Vision
                    </h2>

                    <div className="admission-title-line"></div>

                    <p>
                        To educate, empower and inspire young minds to become
                        knowledgeable, responsible and compassionate individuals
                        who contribute positively to society and the nation.
                    </p>

                </div>

            </div>

        </div>
    );
};

export default AimsObjectives;